import { render } from "./MathopiaLogo.vue?vue&type=template&id=b315937c&scoped=true"
const script = {}

import "./MathopiaLogo.vue?vue&type=style&index=0&id=b315937c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b315937c"

export default script